import React from 'react';
import { FadeIn } from './FadeIn';
import { Power, Droplets, Sun, Flame } from 'lucide-react';
export function RevelationSection() {
  return <section className="py-14 px-4 md:px-6 relative bg-[#0d1326] border-y border-slate-800/50" data-id="element-152">
      <div className="max-w-4xl mx-auto text-center" data-id="element-153">
        <FadeIn data-id="element-154">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-155">
            La mayoría de los consejos de salud te piden meses de esfuerzo.
          </h2>
          <p className="text-xl text-slate-300 mb-8" data-id="element-156">
            Pero tu biología funciona con{' '}
            <span className="text-cyan-400 font-bold" data-id="element-157">
              switches (interruptores)
            </span>
            .
          </p>

          <div className="bg-slate-900/80 border border-cyan-500/30 rounded-2xl p-8 md:p-12 box-glow relative overflow-hidden" data-id="element-158">
            <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-500/10 blur-[80px] rounded-full pointer-events-none" data-id="element-159"></div>

            <p className="text-lg md:text-xl text-slate-300 leading-relaxed relative z-10 mb-8" data-id="element-160">
              He condensado años de ciencia de Biohacking en un protocolo de 7
              días que ataca la raíz del problema: tus{' '}
              <span className="text-cyan-400 font-bold text-glow" data-id="element-161">
                mitocondrias
              </span>
              .
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 relative z-10" data-id="element-162">
              <div className="flex flex-col items-center gap-3" data-id="element-163">
                <Sun className="w-8 h-8 text-cyan-400" data-id="element-164" />
                <span className="text-sm font-semibold text-slate-400 uppercase tracking-wider" data-id="element-165">
                  Luz
                </span>
              </div>
              <div className="flex flex-col items-center gap-3" data-id="element-166">
                <Droplets className="w-8 h-8 text-cyan-400" data-id="element-167" />
                <span className="text-sm font-semibold text-slate-400 uppercase tracking-wider" data-id="element-168">
                  Hidratación
                </span>
              </div>
              <div className="flex flex-col items-center gap-3" data-id="element-169">
                <Flame className="w-8 h-8 text-cyan-400" data-id="element-170" />
                <span className="text-sm font-semibold text-slate-400 uppercase tracking-wider" data-id="element-171">
                  Estresores Térmicos
                </span>
              </div>
            </div>

            <div className="mt-10 pt-8 border-t border-slate-800" data-id="element-172">
              <p className="text-xl md:text-2xl font-bold text-white flex items-center justify-center gap-3" data-id="element-173">
                <Power className="w-6 h-6 text-cyan-400" data-id="element-174" />
                Puedes "encender" tu energía de nuevo.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}